/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { orderDetailsButtonSetStyles } from "@insite/content-library/Widgets/OrderDetails/OrderDetailsButtonSet";
import { css } from "styled-components";

orderDetailsButtonSetStyles.printButton = {
    variant: "secondary",
};

orderDetailsButtonSetStyles.shareEntityButtonStyles = {
    button: {
        variant: "secondary",
        color: "",
    },
};

orderDetailsButtonSetStyles.tabletMenuHidden = {
    below: "md",
    above: "md",
    css: css`
        display: flex;
        align-items: center;
        margin-left: 20px;
        @media print {
            display: none;
        }
    `,
};

orderDetailsButtonSetStyles.menuHidden = {
    above: "sm",
    css: css`
        width: 100%;
        display: flex;
        justify-content: flex-end;
        @media print {
            display: none;
        }
    `,
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin-left: 20px;
        &:empty {
            display: none;
        }
    `,
};
